const paySettlement = [
  {
    path: '/payment-settlement',
    name: 'Pay-Settlement',
    component: () => import('@/components/modules/pay-settlement/index.vue'),
    meta: {
      title: 'Payment Settlement',
      tlabel: 'HEADER_PAYMENT_SETTLEMENT',
      requiresAuth: true,
    },
  },
];

export default paySettlement;
